import React from 'react';
import { motion } from 'framer-motion';
import { Cpu, Database, Globe, Shield, Zap, Code } from 'lucide-react';

const Technology: React.FC = () => {
  const technologies = [
    {
      icon: Cpu,
      title: 'Machine Learning',
      description: 'Advanced ML models for document processing and pattern recognition',
      color: 'text-primary-400'
    },
    {
      icon: Database,
      title: 'Natural Language Processing',
      description: 'Sophisticated NLP for understanding and extracting document content',
      color: 'text-accent-400'
    },
    {
      icon: Globe,
      title: 'Cloud-Native Architecture',
      description: 'Scalable, resilient infrastructure built for enterprise workloads',
      color: 'text-primary-400'
    },
    {
      icon: Shield,
      title: 'API-First Design',
      description: 'RESTful APIs and microservices for seamless integration',
      color: 'text-accent-400'
    },
    {
      icon: Zap,
      title: 'Real-time Processing',
      description: 'High-performance processing with sub-second response times',
      color: 'text-primary-400'
    },
    {
      icon: Code,
      title: 'Enterprise Security',
      description: 'SOC 2 compliance, encryption, and enterprise-grade security',
      color: 'text-accent-400'
    }
  ];

  return (
    <section className="py-20 bg-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-4xl md:text-5xl font-bold font-display mb-6"
          >
            Powered by Enterprise AI
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
            className="text-xl text-gray-300 max-w-3xl mx-auto"
          >
            Cutting-edge technology stack designed for enterprise-scale AI agent applications and document processing.
          </motion.p>
        </div>

        {/* Technology Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {technologies.map((tech, index) => (
            <motion.div
              key={tech.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="glass-effect rounded-xl p-6 card-hover"
            >
              <div className={`w-12 h-12 ${tech.color} mb-4`}>
                <tech.icon size={48} />
              </div>
              <h3 className="text-xl font-semibold mb-3 text-white">{tech.title}</h3>
              <p className="text-gray-400 leading-relaxed">{tech.description}</p>
            </motion.div>
          ))}
        </div>

        {/* Technical Stack Visualization */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          viewport={{ once: true }}
          className="glass-effect rounded-2xl p-8 mb-16"
        >
          <h3 className="text-2xl font-bold mb-8 text-center text-white">Technology Stack</h3>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
            <div className="text-center">
              <div className="text-lg font-semibold text-primary-400 mb-2">Frontend</div>
              <div className="space-y-1 text-sm text-gray-400">
                <div>React / Next.js</div>
                <div>Tailwind CSS</div>
              </div>
            </div>
            <div className="text-center">
              <div className="text-lg font-semibold text-accent-400 mb-2">Backend</div>
              <div className="space-y-1 text-sm text-gray-400">
                <div>Node.js / Python / Golang</div>
                <div>PostgreSQL / DynamoDB</div>
              </div>
            </div>
            <div className="text-center">
              <div className="text-lg font-semibold text-primary-400 mb-2">AI/ML</div>
              <div className="space-y-1 text-sm text-gray-400">
                <div>OpenRouter</div>
                <div>Custom Models</div>
              </div>
            </div>
            <div className="text-center">
              <div className="text-lg font-semibold text-accent-400 mb-2">Infrastructure</div>
              <div className="space-y-1 text-sm text-gray-400">
                <div>AWS EC2 / ECS</div>
                <div>Docker</div>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Performance Metrics */}
        {/* <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          viewport={{ once: true }}
          className="grid grid-cols-1 md:grid-cols-4 gap-8"
        >
          <div className="text-center">
            <div className="text-4xl font-bold gradient-text mb-2">99.9%</div>
            <div className="text-gray-400">Uptime</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold gradient-text mb-2">&lt;500ms</div>
            <div className="text-gray-400">Response Time</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold gradient-text mb-2">10M+</div>
            <div className="text-gray-400">Documents Processed</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold gradient-text mb-2">SOC 2</div>
            <div className="text-gray-400">Compliance</div>
          </div>
        </motion.div> */}
      </div>
    </section>
  );
};

export default Technology; 